import type { IconData } from '@stacksjs/iconify-core'

export const window: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M424 440V48H88v392H48v32h416v-32ZM120 80h120v120H120Zm0 152h120v144H120Zm272 208H120v-32h272Zm0-64H272V232h120Zm0-176H272V80h120Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default window
